module.exports = __webpack_public_path__ + "static/img/arthroscopy-06.890bd07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-06.jpg
// module id = Ef+R
// module chunks = 51